import { Boolean } from "./Filter.Controls.Boolean";
import { Interval } from "./Filter.Controls.Interval";
import { MultiSelect } from "./Filter.Controls.MultiSelect";
import { Dropdown } from "./Filter.Controls.Dropdown";
import { Col, Row } from "./Filter.Controls.style";
import { Icon } from "assets/Icons_";
import { _project } from "state/store.projects";
import { getProjectData } from "state/jotai.projectDataHooks";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { useEffect, useState } from "react";

const dropdownData = {
  Type: "Dropdown",
  Default: [0],
};

export const Controls = ({ active, options, setFilters }) => {
  const { pin, pid } = useGet(active_project);
  const [fOption, setFoption] = useState([])
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const iconLookup = getFocus(_project, "IconLookup")?.[pin]?.[pid] ?? [];

  let lookup = {};

  // const lookup = {
  //   'Husleje'       : 'price',
  //   'Månadshyra'    : 'price',
  //   'Størrelse'     : 'area',
  //   'Storlek'       : 'area',
  //   'Etage'         : 'floor',
  //   'Våning'        : 'floor',
  //   'Status'        : 'status',
  //   'Altantype'     : 'balcony',
  //   'Antal værelser': 'rooms',
  //   'Værelser'      : 'rooms',
  //   'Orientering'   : 'orientation',
  //   'Boligtype'     : 'boligtype',
  //   'Rent per month': 'price',
  //   'Size'          : 'area',
  //   'Floor'         : 'floor',
  // }

  // We have to add "AlleBoligtyper" property for showing ALL unit option in dropdown of UNIT TYPE
  const PossibleValues = getProjectData("unitcategories").map((i, j) => ({
    ID: j,
    Value: !j
      ? buttonsLabel?.filter((btn) => btn?.UILabelProperty === "AlleBoligtyper")[0]
        ?.Label
      : i,
    ValueProperty: "Boligtype",
  }));

  iconLookup?.forEach((icon) => {
    lookup[icon?.Property] = icon?.Label;
  });

  dropdownData.PossibleValues = PossibleValues;
  dropdownData.Label = buttonsLabel?.filter(
    (btn) => btn?.UILabelProperty === "Boligtype"
  )[0]?.Label;

  // if (!options.filter((i) => i.Type == "Dropdown").length > 0) {
  //   options.push(dropdownData);
  // }

  useEffect(()=> {
    if(options) {
   
      let newOption = options.map(option => ({ ...option }));

      if(active?.multiSelect && active?.multiSelect.length) {
        const isTypeAvail = active?.multiSelect.filter(m => m.property === 'Type') // user have choose type for unit
        let isStatusO = newOption?.filter(m => m.Label === "Status") // taking only status multiselect data

        if(isStatusO.length && isTypeAvail.length && isTypeAvail[0].values.length === 1) {
          // filter for multiselect status
          isStatusO[0].PossibleValues = isStatusO[0].PossibleValues?.filter((pv) => {
            if(isTypeAvail[0].values?.[0] === "SalesTypeEjerlejlighed" && pv.ID === 30) return false
            else if(isTypeAvail[0].values?.[0] === "SalesTypeLejelejlighed" && pv.ID === 40) return false
            return true
          })

          // filter for prices husleje and kontantpris
          newOption = newOption.filter((no) => {
            if(isTypeAvail[0].values?.[0] === "SalesTypeEjerlejlighed" && no.FilterFor === "Husleje") return false
            else if(isTypeAvail[0].values?.[0] === "SalesTypeLejelejlighed" && no.FilterFor === "Kontantpris") return false
            return true
          })
        }
      }

      setFoption(newOption)
    }  
  }, [active?.multiSelect, options])

  return (
    <>
      {fOption.map(({ Type, Label, ...i }, j) => {
        const props = { ...i, active, setFilters, key: j, index: j, Label };
        const icon = { icon: lookup[Label], color: clr?.icons, size: 20 };
      
        // not rendering component which have 0 or null values
        if(i.hasOwnProperty("MinValue") && i.hasOwnProperty("MaxValue")) {
          if(!i.MinValue && !i.MaxValue) return null
        }else {
          if(!i.PossibleValues.length) return null
        }

        return (
          <Col key={j}>
            <div
              style={{
                border: "0px solid black",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingBottom: "10px",

              }}
            >
              <Icon clr={clr}{...icon}
              isFaIcon={(icon?.icon === "area" || icon?.icon === "floor" || icon?.icon === "unit") ? false : true}
              size={(icon?.icon === "area" || icon?.icon === "floor" || icon?.icon === "unit") && 16}
              />
              <div style={{ flex: "0 0 5px" }} />
              <div style={{
                position: "relative", color: `${clr.primary_text}`,
                whiteSpace: "nowrap"
              }} className="paragraph1-regular">{Label}</div>
            </div>
            <Row btnType={Label}>
              {Type === "MultiSelect" && <MultiSelect {...props} />}
              {Type === "MultiRange" && <Interval {...props} />}
              {Type === "Boolean" && <Boolean {...props} />}
              {Type === "Dropdown" && <Dropdown {...props} />}
            </Row>
          </Col>
        );
      })}
    </>
  );
};
